import { render, staticRenderFns } from "./AllClasses.vue?vue&type=template&id=d873b400"
import script from "./AllClasses.vue?vue&type=script&lang=js"
export * from "./AllClasses.vue?vue&type=script&lang=js"
import style0 from "./AllClasses.vue?vue&type=style&index=0&id=d873b400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports